import React from 'react'
import { Div } from 'glamorous'

import LoadingSpinner from 'components/common/LoadingSpinner'

const LoadingScreen = () => {
  return (
    <Div
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <LoadingSpinner size={48} />
    </Div>
  )
}

export default LoadingScreen



// WEBPACK FOOTER //
// ./src/components/common/LoadingScreen.js